import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-databaseviewer',
  templateUrl: './databaseviewer.component.html',
  styleUrls: ['./databaseviewer.component.css']
})
export class DatabaseviewerComponent implements OnInit {

  @Input() database: any;
  @Input() title: string;
  public mobileNumberMask = ['(', /[0-9]/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];


  constructor() { }

  ngOnInit() {
  }

}
